var _g, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _path6, _circle6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChemistryicon = function SvgChemistryicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.2 111.5-29-46.9c-.8-1.2-1.3-1.9-1.2-4.3v-19c0-.5.2-.7.6-.7h2.5c3 0 2.8-3.9 2.8-3.9s.2-3.7-3-3.9H53.3c-2.3 0-2.4 3.4-2.4 3.4s-.2 4.3 2.4 4.3h3c.6 0 .6.5.6.7V60c0 1.8.1 2.9-1.2 4.4L26 112.5c-7 15.1-.4 32.2 16.9 33.4h63.3c16-.9 26.6-17.1 17-34.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 63.3,
    r: 7.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M13.3 66.4c2.7 2.6 5.9 2.7 6.9-.1.2-.9-.2-1.4-.6-1.5-1-.3-2 .6-2.7.6-.8-.1-2-1.9-2.8-1.8-2-.1-1.7 2.1-.8 2.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 12.4,
    r: 7.3,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M44.3 7c-3.9.1-6.2 2.3-4.9 5 .5.8 1.2.9 1.5.7.9-.5 1-1.9 1.5-2.4.7-.6 2.8-.1 3.4-.8 1.5-1.3-.3-2.6-1.5-2.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.2,
    cy: 15.1,
    r: 6.5,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M114.9 14.2c-.1-3.4-2.1-5.5-4.5-4.4-.7.4-.8 1-.6 1.3.4.8 1.7.9 2.1 1.4.5.6.1 2.5.7 3 1.2 1.4 2.4-.2 2.3-1.3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 70.6,
    r: 5.7,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M122.6 66.4c-3 .1-4.9 1.8-3.9 3.9.4.6.9.7 1.2.5.7-.4.8-1.5 1.2-1.8.5-.4 2.2-.1 2.6-.6 1.3-1.1-.2-2.1-1.1-2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.7,
    cy: 16,
    r: 11.9,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M76.4 24.8c6.3-.2 10.1-3.8 8-8.2-.8-1.3-1.9-1.4-2.4-1.1-1.5.8-1.6 3.1-2.5 3.8-1.1.9-4.6.2-5.5 1.2-2.4 2.3.5 4.4 2.4 4.3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.4,
    cy: 36.9,
    r: 4.2,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M135.9 33.8c-2.2.1-3.6 1.4-2.9 2.9.3.5.7.5.9.4.5-.3.6-1.1.9-1.4.4-.3 1.6-.1 1.9-.4.9-.8-.1-1.6-.8-1.5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9,
    cy: 36.1,
    r: 3.4,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "props.color",
    d: "M38.2 33.6c-1.8.1-2.9 1.1-2.3 2.3.2.4.5.4.7.3.4-.2.5-.9.7-1.1.3-.3 1.3 0 1.6-.4.7-.6-.1-1.2-.7-1.1m79.9 83.7s-9.8-17-12.2-20c-.4-.7-1.1-.5-1.4-.4-2.2.5-6.3 2.3-8.7 4.4-1.6 3.1-5.7 4.1-5.7 4.1-2.6.6-4.6 0-6.7-1.3-2-.4-5.4.4-8.3.3-13.6-.8-26.7-6.8-30-7.5-1.1-.3-1.1 0-1.6.5-2.8 2.9-11.7 19.9-11.7 19.9-4.2 9.5 1.4 20.2 10.7 20.5h63.8c10.2-.3 16.2-11 11.8-20.5m-78.9 13c-2.2 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.8 4.1-4.1 4.1m22-9.7c-2.2 0-4.1-1.8-4.1-4.1 0-2.2 1.8-4.1 4.1-4.1 2.2 0 4.1 1.8 4.1 4.1-.1 2.2-1.9 4.1-4.1 4.1m24.2 14.1c-4.5 0-8.1-3.6-8.1-8.1s3.6-8.1 8.1-8.1 8.1 3.6 8.1 8.1-3.7 8.1-8.1 8.1m21.7-8.3c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8M60.5 87.2c-2.6 0-4.6 2.1-4.6 4.6 0 2.6 2.1 4.6 4.6 4.6s4.6-2.1 4.6-4.6-2.1-4.6-4.6-4.6m1.4 2.9c-.3.4-1.7.1-2.1.5-.3.3-.4 1.2-1 1.5-.2.1-.6.1-.9-.4-.8-1.7.7-3.1 3.1-3.2.7-.1 1.9.7.9 1.6m13.3-26.4c-4.6 0-8.4 3.7-8.4 8.4 0 4.6 3.7 8.4 8.4 8.4 4.6 0 8.4-3.7 8.4-8.4s-3.8-8.4-8.4-8.4m2.5 5.2c-.6.8-3.1.2-3.8.9-.6.5-.7 2.1-1.7 2.7-.4.3-1.2.2-1.7-.7-1.5-3.1 1.2-5.6 5.7-5.8 1.2-.2 3.3 1.3 1.5 2.9m10.6 20.3c-4.3 0-7.7 3.4-7.7 7.7s3.4 7.7 7.7 7.7 7.7-3.4 7.7-7.7-3.5-7.7-7.7-7.7m2.3 4.8c-.6.7-2.8.2-3.5.8-.6.5-.6 2-1.6 2.5-.3.2-1.1.2-1.6-.7-1.4-2.8 1.1-5.2 5.2-5.3 1.3-.2 3.2 1.2 1.5 2.7"
  })));
};
export default SvgChemistryicon;